/* Organic Fiber extras: videos that load when seen, the Mantra bowl room and the scarf try-on */
(function () {
  var S = window.OFSound;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Videos load only when they come near the screen */
  var saveData = navigator.connection && navigator.connection.saveData;
  function tryPlay(v) { var p = v.play(); if (p && p.then) p.then(null, function () {}); }
  function startVideo(v) {
    if (v.dataset.on || saveData) return;
    if (document.readyState !== 'complete') { window.addEventListener('load', function () { setTimeout(function () { startVideo(v); }, 1200); }); return; }
    v.dataset.on = '1'; v.muted = true; v.defaultMuted = true;
    v.addEventListener('playing', function () { v.classList.add('on'); });
    v.src = v.dataset.src;
    if (v.hasAttribute('data-auto')) tryPlay(v);
  }
  /* Phones in low power mode block autoplay until the first tap, so try again then */
  ['touchend', 'click'].forEach(function (type) {
    window.addEventListener(type, function () {
      $$('video[data-auto]').forEach(function (v) { if (v.dataset.on && v.paused) tryPlay(v); });
    }, { once: true, passive: true });
  });
  function whenSeen(items, fn) {
    if (!('IntersectionObserver' in window)) { items.forEach(fn); return; }
    var io = new IntersectionObserver(function (seen) {
      seen.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fn(e.target); } });
    }, { rootMargin: '300px' });
    items.forEach(function (x) { io.observe(x); });
  }
  whenSeen($$('[data-lazy-video]'), startVideo);

  /* The Mantra bowl: tap to hear the real recording */
  $$('[data-mantra-room]').forEach(function (room) {
    if (!S) return;
    var audio = S.track(new Audio(room.dataset.src)), stage = $('[data-stage]', room), rings = $('[data-rings]', room), count = $('[data-strikes]', room), hits = 0, timer;
    audio.preload = 'auto';
    function ring() { var r = document.createElement('i'); rings.appendChild(r); setTimeout(function () { r.remove(); }, 4400); }
    $('[data-bowl]', room).addEventListener('click', function () {
      S.route(audio); audio.currentTime = 0; var p = audio.play(); if (p && p.then) p.then(null, function () {});
      hits++; count.textContent = hits;
      [0, 380, 820, 1350].forEach(function (d) { setTimeout(ring, d); });
      stage.classList.remove('ringing'); void stage.offsetWidth; stage.classList.add('ringing');
      clearTimeout(timer); timer = setTimeout(function () { stage.classList.remove('ringing'); }, 5000);
    });
  });

  /* Option buttons for color and size, which choose the variant in the hidden list */
  var sel = $('#variantSel'), groups = $$('[data-opt-group]');
  if (sel && groups.length) {
    var opts = $$('option', sel), cur = [], sent = sel.value, photos = $$('[data-gal][data-opt1]');
    function find(want) {
      return opts.filter(function (o) { return !o.disabled && want.every(function (w, i) { return !w || o.dataset['o' + (i + 1)] === w; }); })[0];
    }
    function paint() {
      var o = sel.options[sel.selectedIndex];
      cur = [o.dataset.o1, o.dataset.o2, o.dataset.o3];
      groups.forEach(function (g, i) {
        $$('[data-opt-value]', g).forEach(function (b) {
          var want = cur.slice(); want[i] = b.dataset.optValue;
          var out = !find(want);
          b.setAttribute('aria-pressed', b.dataset.optValue === cur[i]);
          b.setAttribute('aria-disabled', out);
          b.setAttribute('aria-label', b.dataset.optValue + (out ? ', not available' : ''));
          b.classList.toggle('is-out', out);
        });
        $('[data-opt-now]', g).textContent = cur[i] || '';
      });
    }
    function choose(want, i) {
      var only = want.map(function (w, n) { return n === i ? w : ''; });
      var hit = find(want) || find(only);
      if (hit) sel.value = hit.value;
      paint();
      if (sel.value !== sent) { sent = sel.value; sel.dispatchEvent(new Event('change')); }
    }
    groups.forEach(function (g, i) {
      $$('[data-opt-value]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          var want = cur.slice(); want[i] = b.dataset.optValue;
          if (i === 0) { var t = photos.filter(function (x) { return x.dataset.opt1 === b.dataset.optValue; })[0]; if (t) t.click(); }
          choose(want, i);
        });
      });
    });
    photos.forEach(function (t) { t.addEventListener('click', function () { var want = cur.slice(); want[0] = t.dataset.opt1; choose(want, 0); }); });
    paint();
  }

  /* Scarf try-on: finds the gray scarf on the mannequin photo and dresses it in the chosen scarf */
  $$('[data-tryon]').forEach(function (box) {
    var canvas = $('[data-tryon-canvas]', box), picks = $$('[data-tryon-pick]', box), base = null, mask = null, mean = 150, W = 0, H = 0, cache = {}, wanted = '';
    if (!canvas || !picks.length) return;
    var ctx = canvas.getContext('2d');
    function load(url, done) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { done(i); }; i.src = url; }
    function pixels(img, w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h); return x.getImageData(0, 0, w, h); }
    function prepare(img) {
      W = img.naturalWidth; H = img.naturalHeight; canvas.width = W; canvas.height = H;
      base = pixels(img, W, H); mask = new Float32Array(W * H);
      var d = base.data, sum = 0, n = 0, sx = W / 1086, sy = H / 1448;
      for (var y = Math.floor(290 * sy); y < 1320 * sy; y++) for (var x = Math.floor(170 * sx); x < 720 * sx; x++) {
        var i = (y * W + x) * 4, hi = Math.max(d[i], d[i + 1], d[i + 2]), lo = Math.min(d[i], d[i + 1], d[i + 2]), l = (d[i] + d[i + 1] + d[i + 2]) / 3, s = hi - lo;
        if (s < 20 && l > 55 && l < 222) { var a = (1 - Math.max(0, (s - 13) / 7)) * Math.min(1, (222 - l) / 10); mask[y * W + x] = a; if (a > .5) { sum += l; n++; } }
      }
      if (n) mean = sum / n;
    }
    function mirror(v, m) { v = ((v % (2 * m)) + 2 * m) % (2 * m); return v > m ? 2 * m - v : v; }
    function dress(tex) {
      var tw = tex.width, th = tex.height, t = tex.data, sx = W / 1086, sy = H / 1448, fr = [0, 0, 0], fn = 0, x, y, i, n;
      for (y = Math.floor(th * .86); y < th * .93; y += 3) for (x = Math.floor(tw * .15); x < tw * .85; x += 3) { i = (y * tw + x) * 4; if (t[i] < 250 || t[i + 1] < 250) { fr[0] += t[i]; fr[1] += t[i + 1]; fr[2] += t[i + 2]; fn++; } }
      if (fn) fr = fr.map(function (v) { return v / fn; });
      var L = 110, R = 910, T0 = 110, B = 1100, K = .24, out = ctx.createImageData(W, H), p = out.data, d = base.data;
      p.set(d);
      for (y = Math.floor(300 * sy); y < 1320 * sy; y++) for (x = Math.floor(170 * sx); x < 720 * sx; x++) {
        var k = y * W + x, a = mask[k]; if (a <= 0) continue;
        i = k * 4;
        var l = (d[i] + d[i + 1] + d[i + 2]) / 3, ox = x / sx, oy = y / sy, c, shade;
        if (oy > 1128) { c = fr; shade = Math.min(1.2, l / 150); }
        else {
          shade = 1 + (Math.min(1.25, Math.max(.4, l / mean)) - 1) * 1.15;
          var edge = oy > 560 ? 205 + Math.max(0, 1000 - oy) * .09 : 300 - (oy - 300) * .05;
          var j = (Math.floor(B - mirror((1130 - oy) / K, B - T0)) * tw + Math.floor(L + mirror((ox - edge) / K, R - L))) * 4;
          c = [t[j], t[j + 1], t[j + 2]];
        }
        for (n = 0; n < 3; n++) p[i + n] = d[i + n] * (1 - a) + Math.min(255, c[n] * shade) * a;
      }
      return out;
    }
    function draw(id) { if (cache[id] && wanted === id) { ctx.putImageData(cache[id], 0, 0); canvas.classList.add('on'); } }
    function show(id) {
      var b = picks.filter(function (x) { return x.dataset.variant === String(id); })[0]; if (!b) return;
      wanted = b.dataset.variant;
      picks.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      var name = $('[data-tryon-name]', box); if (name) name.textContent = b.dataset.name;
      if (!base) return;
      if (cache[wanted]) { draw(wanted); return; }
      var id2 = wanted;
      load(b.dataset.src, function (img) { cache[id2] = dress(pixels(img, 1024, 1536)); draw(id2); });
    }
    var thumbs = $$('[data-gal][data-variant]');
    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        var t = thumbs.filter(function (x) { return x.dataset.variant === b.dataset.variant; })[0];
        if (t) t.click(); else show(b.dataset.variant);
      });
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.variant); }); });
    whenSeen([box], function () {
      load(box.dataset.base, function (img) { try { prepare(img); show(wanted || picks[0].dataset.variant); } catch (err) {} });
    });
  });
})();
